module.exports = ".padtop20 {\r\n    padding-top: 20px\r\n}\r\n.padtop10 {\r\n    padding-top: 10px\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/invoice-view/invoice-view.component.css
// module id = ./src/app/invoice-view/invoice-view.component.css
// module chunks = main